import { dateToView } from "helpers/date";
import { RealtimeManager } from "../../realtime";

export const handleBidPointDatesUpdate = (payload) => {
    const {
        id: bidId,
        carId,
        status,
        loadUnloadStatus,
        lastBidPoint,
        withoutBidPeriod,
        isCarOnServicePoint,
        isLastBidPointVisited,
    } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.bidId === bidId && item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.lastPointLoadUnloadedAtByLogist = lastBidPoint.leftAtByLogist;
        findItem.bidPointLoadUnloadStatus = loadUnloadStatus;
        findItem.bidStatus = status;
        findItem.withoutBidPeriod = withoutBidPeriod;
        findItem.isCarOnServicePoint = isCarOnServicePoint;
        findItem.isLastBidPointVisited = isLastBidPointVisited;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[${bidId}&${carId}]`, (item) => ({
        ...item,
        lastPointLoadUnloadedAtByLogist: lastBidPoint.leftAtByLogist,
        bidPointLoadUnloadStatus: loadUnloadStatus,
        bidStatus: status,
        withoutBidPeriod,
        isCarOnServicePoint,
        isLastBidPointVisited,
    }));
};

export const handleBookingCommentUpdate = (payload) => {
    const { id: carId, bookingComment } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.bookingComment = bookingComment;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[carId(${carId})]`, (item) => ({ ...item, bookingComment }));
};

export const handleCarUpdate = (payload) => {
    const {
        id: carId,
        logistId,
        number,
        logist,
        transportColumn,
        needsMaintenanceComment,
        needsUrgentMaintenance,
        accessPermitIds,
    } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.number = number;
        findItem.carLogistId = logistId;
        findItem.carLogistDisplayName = logist?.displayName;
        findItem.transportColumnId = transportColumn?.id;
        findItem.transportColumnName = transportColumn?.name;
        findItem.carNeedsMaintenanceComment = needsMaintenanceComment;
        findItem.carNeedsUrgentMaintenance = needsUrgentMaintenance;
        findItem.carAccessPermitIds = accessPermitIds;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[carId(${carId})]`, (item) => ({
        ...item,
        number,
        carLogistId: logistId,
        carLogistDisplayName: logist?.displayName,
        transportColumnId: transportColumn?.id,
        transportColumnName: transportColumn?.name,
        carNeedsMaintenanceComment: needsMaintenanceComment,
        carNeedsUrgentMaintenance: needsUrgentMaintenance,
        carAccessPermitIds: accessPermitIds,
    }));
};

export const handleDriverUpdate = (payload) => {
    const { id: driverId, displayName, needsShiftChangeComment, needsUrgentShiftChange, accessPermitIds } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.bidDriverId === driverId);

        if (!findItem) {
            continue;
        }

        findItem.bidDriverDisplayName = displayName;
        findItem.driverNeedsShiftChangeComment = needsShiftChangeComment;
        findItem.driverNeedsUrgentShiftChange = needsUrgentShiftChange;
        findItem.driverAccessPermitIds = accessPermitIds;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[bidDriverId(${driverId})]`, (item) => ({
        ...item,
        bidDriverDisplayName: displayName,
        driverNeedsShiftChangeComment: needsShiftChangeComment,
        driverNeedsUrgentShiftChange: needsUrgentShiftChange,
        driverAccessPermitIds: accessPermitIds,
    }));
};

export const handleEstimatedLeaveDateUpdate = (payload) => {
    const { id: bidId, carId, logistId, logist, manualEstimatedLeaveDate, estimatedLeaveDate } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.bidId === bidId && item.carId === carId);

        if (!findItem) {
            continue;
        }

        const findColumn = manualEstimatedLeaveDate
            ? originalData.columns.find((item) => item.label === dateToView(manualEstimatedLeaveDate))
            : null;

        // в будущем делать ближайший индекс от даты,
        // сейчас проставляем "out-range", госномер не показываться в таблице
        findItem.index = findColumn ? findColumn.index : "out-range";
        findItem.carLogistId = logistId;
        findItem.carLogistDisplayName = logist?.displayName;
        findItem.manualEstimatedLeaveDate = manualEstimatedLeaveDate;
        findItem.estimatedLeaveDate = estimatedLeaveDate;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[]`, () => JSON.parse(JSON.stringify(originalData)));
};

export const handleCarHasPlannedBidUpdate = (payload) => {
    const { id: carId, hasPlannedBid } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.hasPlannedBid = hasPlannedBid;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[carId(${carId})]`, (item) => ({ ...item, hasPlannedBid }));
};

export const handlePlanningCommentUpdate = (payload) => {
    const { id: carId, planningComment, userFullName } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.carPlanningComment = planningComment ? { ...planningComment, createdBy: userFullName } : null;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[carId(${carId})]`, (item) => ({
        ...item,
        carPlanningComment: planningComment ? { ...planningComment, createdBy: userFullName } : null,
    }));
};

export const handleCarResourceActivityUpdate = (payload) => {
    const { id: carId, isActive, resourceInactivityInfo } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.carId === carId);

        if (!findItem) {
            continue;
        }

        findItem.carIsActive = isActive;
        findItem.carInactivityReason = resourceInactivityInfo?.inactivityReason;
        findItem.carInactiveSince = resourceInactivityInfo?.inactiveSince;
        findItem.carInactiveUntil = resourceInactivityInfo?.inactiveUntil;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[carId(${carId})]`, (item) => ({
        ...item,
        carIsActive: isActive,
        carInactivityReason: resourceInactivityInfo?.inactivityReason,
        carInactiveSince: resourceInactivityInfo?.inactiveSince,
        carInactiveUntil: resourceInactivityInfo?.inactiveUntil,
    }));
};

export const handleTrailerUpdate = (payload) => {
    const { id: trailerId, number, typeId, accessPermitIds } = payload;

    const originalData = RealtimeManager.getOriginalData();

    // мутация
    for (const { factOrPlanBidEndDates } of originalData?.data ?? []) {
        const findItem = factOrPlanBidEndDates.find((item) => item.bidTrailerId === trailerId);

        if (!findItem) {
            continue;
        }

        findItem.bidTrailerTypeId = typeId;
        findItem.bidTrailerNumber = number;
        findItem.trailerAccessPermitIds = accessPermitIds;
    }

    // уведомление
    RealtimeManager.pendingNotify(`data[bidTrailerId(${trailerId})]`, (item) => ({
        ...item,
        bidTrailerTypeId: typeId,
        bidTrailerNumber: number,
        trailerAccessPermitIds: accessPermitIds,
    }));
};
